import { render, staticRenderFns } from "./newsfq.vue?vue&type=template&id=7c2d64b2&scoped=true&"
import script from "./newsfq.vue?vue&type=script&lang=js&"
export * from "./newsfq.vue?vue&type=script&lang=js&"
import style0 from "./newsfq.vue?vue&type=style&index=0&id=7c2d64b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d64b2",
  null
  
)

export default component.exports